/**
 * is Development?
 */

const clipGetType = function(clip) {
    if (!clip || !clip.getMedia)
        return 'unknown';

    let media = clip.getMedia();
    if (media.asString().indexOf('video') > -1)
        return 'video';
    if (media.has('pictures'))
        return 'picture';
    return 'unknown';
}

export default clipGetType;